import { createAction, props } from '@ngrx/store';
import { EventsFilter } from '../../services/component-data-filter/data/events-filter';

export const loadCalendarEvents = createAction(
  '[Events] Load Calendar Events',
  props<{ 
    filters?: EventsFilter | null;
    queryParams?: any;
    /** When true, drop cached events before applying the response (filter change, list view). */
    replaceCache?: boolean;
  }>()
);

export const loadCalendarEventsSuccess = createAction(
  '[Events] Load Calendar Events Success',
  props<{ data: any[]; queryParams?: Record<string, unknown> }>()
);

export const loadCalendarEventsFailure = createAction(
  '[Events] Load Calendar Events Failure',
  props<{ error: any }>()
);

export const cancelCalendarEventsLoad = createAction(
  '[Events] Cancel Calendar Events Load'
);

export const updateEventsFilters = createAction(
  '[Events] Update Filters',
  props<{ filters: EventsFilter | null }>()
);

export const clearEventsData = createAction(
  '[Events] Clear Events Data'
);

